import * as React from 'react'

class About extends React.PureComponent {
  render() {
    return <span>ABOUT</span>
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/Modal/About/index.tsx